// components/calendar/AgendaCalendarEvent.jsx
import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { AccessTime as AccessTimeIcon } from '@mui/icons-material';
import { differenceInMinutes } from 'date-fns';
import { getEstadoConfig, formatDuration } from './agendaCalendar.constants';

const EventComponent = ({ event }) => {
    const estado = getEstadoConfig(event.resource.manest);
    const duration = event.resource.duracion_minutos
        ? formatDuration(event.resource.duracion_minutos)
        : formatDuration(differenceInMinutes(event.end, event.start));

    return (
        <Box sx={{ overflow: 'hidden', height: '100%', cursor: 'pointer' }}>
            <Stack spacing={0.5}>
                <Stack direction="row" alignItems="center" spacing={0.75}>
                    <Box
                        sx={{
                            width: 8, height: 8, borderRadius: '50%',
                            bgcolor: estado.border, flexShrink: 0,
                            ...(event.resource.manest === 'EN_PROCESO' && {
                                animation: 'pulse 2s infinite',
                                '@keyframes pulse': {
                                    '0%': { opacity: 1, transform: 'scale(1)' },
                                    '50%': { opacity: 0.5, transform: 'scale(1.2)' },
                                    '100%': { opacity: 1, transform: 'scale(1)' },
                                },
                            }),
                        }}
                    />
                    <Typography variant="caption" sx={{ fontWeight: 800, fontSize: '0.7rem', letterSpacing: 0.3, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {event.resource.codigo}
                    </Typography>
                    {duration && (
                        <Typography variant="caption" sx={{ fontSize: '0.65rem', color: 'text.secondary', ml: 'auto', display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <AccessTimeIcon sx={{ fontSize: '0.65rem' }} />
                            {duration}
                        </Typography>
                    )}
                </Stack>
                <Typography variant="body2" sx={{ fontSize: '0.7rem', fontWeight: 500, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {event.title}
                </Typography>
                <Stack direction="row" spacing={1} sx={{ opacity: 0.7 }}>
                    <Typography variant="caption" sx={{ fontSize: '0.6rem' }}>{event.resource.horaStr}</Typography>
                    <Typography variant="caption" sx={{ fontSize: '0.6rem' }}>{event.resource.placa}</Typography>
                </Stack>
            </Stack>
        </Box>
    );
};

export default EventComponent;